import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'grapesjs'. '/Users/dkrajnak/workspace/aviso/sse-frontend/react/node_modules/grapesjs/dist/grapes.min.js' implicitly has an 'any' type.
import GrapesJS from "grapesjs";
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'grapesjs-mjml'. '/Users/dkrajnak/workspace/aviso/sse-frontend/react/node_modules/grapesjs-mjml/dist/grapesjs-mjml.min.js' implicitly has an 'any' type.
import grapesJSMJML from "grapesjs-mjml";
import "grapesjs/dist/css/grapes.min.css";
import React from "react";
import CampaignActionDomainService from "../../../Domain/CampaignAction/CampaignAction.service";
import useUniqueId from "../../Hooks/useUniqueId";
import { getXSRF } from "../../../Services/Shared/FetchService";
import { ModalLinkEditor } from "./ModalLinkEditor";
const MJMLSupplementalPlugin = (editor) => {
    editor.BlockManager.remove("mj-raw");
    editor.BlockManager.remove("mj-wrapper");
    editor.on("load", () => {
        const blockBtn = editor.Panels.getButton("views", "open-blocks");
        blockBtn.set("active", 1);
        editor.DomComponents.getWrapper().set("style", { height: "100%" });
        editor.Panels.removeButton("options", "export-template");
        editor.Panels.removeButton("options", "mjml-import");
    });
};
const updateEditorJSON = (editor, json) => {
    try {
        if (editor) {
            // components can either be JSON or HTML.  We'll try to parse it as JSON and if we can't, we'll assume it's HTML.
            let parsedJSON = json;
            try {
                parsedJSON = JSON.parse(json);
            }
            catch (ex) {
                // Don't do anything.  This is probably html
            }
            editor.setComponents(parsedJSON || null);
        }
        else {
            console.log("no editor!");
        }
    }
    catch (error) {
        if (console.error) {
            console.error("could not set editor json", error);
        }
    }
};
const updateEditorStylesJSON = (editor, json) => {
    try {
        if (editor) {
            editor.setStyle(json ? JSON.parse(json) : null);
        }
    }
    catch (error) {
        if (console.error) {
            console.error("could not set editor styles json", error);
        }
    }
};
const updateEditorAssets = (editor, assetsJSON) => {
    try {
        if (editor) {
            editor.AssetManager.add(assetsJSON ? JSON.parse(assetsJSON) : null);
        }
    }
    catch (error) {
        if (console.error) {
            console.error("could not set editor assets json", error);
        }
    }
};
const BASE_MJML_CONTENT = `
<mjml>
    <mj-body>
    </mj-body>
  </mjml>`;
/**
 * Our standard wsywig editor
 *
 * @type {React$Component}
 */
const Editor = ({ onHTMLChange, onJSONChange, onEditorStylesChange, onEditorAssetsChange, json, styleJSON, editorAssets, templateMenuItems, campaignTypeId, isInvalid, invalidFeedback, }) => {
    const editor = React.useRef();
    // make a random id
    const id = useUniqueId()[1]("grapes-js");
    const onHTMLChangeRef = React.useRef(onHTMLChange);
    React.useEffect(() => {
        onHTMLChangeRef.current = onHTMLChange;
    }, [onHTMLChange]);
    const onJSONChangeRef = React.useRef(onJSONChange);
    React.useEffect(() => {
        onJSONChangeRef.current = onJSONChange;
    }, [onJSONChange]);
    const onEditorStylesChangeRef = React.useRef(onEditorStylesChange);
    React.useEffect(() => {
        onEditorStylesChangeRef.current = onEditorStylesChange;
    }, [onEditorStylesChange]);
    const onEditorAssetsChangeRef = React.useRef(onEditorAssetsChange);
    React.useEffect(() => {
        onEditorAssetsChangeRef.current = onEditorAssetsChange;
    }, [onEditorAssetsChange]);
    const [wasUpdated, setWasUpdated] = React.useState(false);
    React.useEffect(() => {
        const edt = GrapesJS.init({
            cssIcons: null,
            container: `#${id}`,
            fromElement: true,
            storageManager: {
                id: "gjs-", // Prefix identifier that will be used on parameters
                type: "none", // Type of the storage
                autosave: true, // Store data automatically
                autoload: false, // Autoload stored data on init
                stepsBeforeSave: 1, // If autosave enabled, indicates how many changes are necessary before store method is triggered
            },
            assetManager: {
                upload: "/aviso/campaign/uploadAssets",
                headers: {
                    "X-XSRF-TOKEN": getXSRF(),
                },
            },
            plugins: [grapesJSMJML, MJMLSupplementalPlugin, ModalLinkEditor],
            noticeOnUnload: 0,
        });
        edt.on("update", () => {
            var _a;
            setWasUpdated(true);
            onHTMLChangeRef.current(edt.runCommand("mjml-get-code").html);
            onJSONChangeRef.current(JSON.stringify(edt.getComponents()));
            onEditorStylesChangeRef.current(JSON.stringify(edt.getStyle()));
            onEditorAssetsChangeRef.current(JSON.stringify((_a = edt.AssetManager) === null || _a === void 0 ? void 0 : _a.getAll()));
        });
        // Auto opens the settings when a link is selected in the editor UI
        edt.on("component:selected", (component) => {
            if (component.attributes.type === "link") {
                edt.Panels.getButton("views", "open-tm").set("active", true);
            }
        });
        edt.Panels.addPanel({ id: "options" })
            .get("buttons")
            .add([
            {
                id: "help-article",
                command() {
                    var _a;
                    (_a = window
                        .open("https://support.watermarkinsights.com/hc/en-us/articles/11305924795291-Using-the-Drag-and-Drop-Editor#h_01HT2VE5GZSM4PQS19B35CRBKE", "_blank")) === null || _a === void 0 ? void 0 : _a.focus();
                },
                className: "fa fa-info-circle",
                attributes: {
                    title: "For more information, refer to this help article",
                },
            },
        ]);
        editor.current = edt;
        return () => {
            // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
            GrapesJS.editors = GrapesJS.editors.filter((e) => e !== edt);
            edt.destroy();
            if (document) {
                const container = document.getElementById(id);
                if (container) {
                    container.innerHTML = "";
                }
            }
        };
    }, [id]);
    React.useEffect(() => {
        /*
        We treat undefined as "no initial value".  This is the consequence of grapesJS not meshing super well with React.
        We have to set an initial value for the MJML GrapesJS plugin, but that initial value is complex JSON that could
        change as we update the editor.  Instead of explicitly setting that, we just take json being undefined as there
        being no initial value for this component and therefore, when it's undefined, we don't change the editor's value.
         */
        if (!wasUpdated && json !== undefined) {
            updateEditorJSON(editor.current, json);
        }
    }, [json, wasUpdated]);
    React.useEffect(() => {
        if (!wasUpdated) {
            updateEditorStylesJSON(editor.current, styleJSON);
        }
    }, [styleJSON, wasUpdated]);
    React.useEffect(() => {
        if (!wasUpdated) {
            updateEditorAssets(editor.current, editorAssets);
        }
    }, [editorAssets, wasUpdated]);
    React.useEffect(() => {
        if (templateMenuItems && editor.current) {
            editor.current.RichTextEditor.add("custom-vars", {
                icon: `<select class="gjs-field" style="color: white">
                <option value="">- Select -</option>
                ${templateMenuItems
                    .map((menu) => {
                    // @ts-expect-error - TS2339 - Property 'link' does not exist on type 'TemplateMenuItem'.
                    const value = menu.link
                        ? // @ts-expect-error - TS2339 - Property 'value' does not exist on type 'TemplateMenuItem'. | TS2339 - Property 'link' does not exist on type 'TemplateMenuItem'.
                            `<a href=&quot;\$\{${menu.value}\}&quot;>${menu.link.linkText}</a>`
                        : // @ts-expect-error - TS2339 - Property 'value' does not exist on type 'TemplateMenuItem'.
                            "${" + menu.value + "}";
                    return `<option value="${value}">${menu.text}</option>`;
                })
                    .join("")}
            </select>`,
                // Bind the 'result' on 'change' listener
                event: "change",
                // @ts-expect-error - TS7006 - Parameter 'rte' implicitly has an 'any' type. | TS7006 - Parameter 'action' implicitly has an 'any' type.
                result: (rte, action) => rte.insertHTML(action.btn.firstChild.value),
                // Reset the select on change
                // @ts-expect-error - TS7006 - Parameter 'rte' implicitly has an 'any' type. | TS7006 - Parameter 'action' implicitly has an 'any' type.
                update: (rte, action) => {
                    action.btn.firstChild.value = "";
                },
            });
        }
        return () => {
            if (editor.current) {
                editor.current.RichTextEditor.remove("custom-vars");
            }
        };
    }, [templateMenuItems]);
    React.useEffect(() => {
        if (campaignTypeId === CampaignActionDomainService.AppointmentId) {
            editor.current.BlockManager.add("appointment-block", {
                label: "Aviso Appointment Link",
                attributes: {
                    class: "fa fa-link gjs-block gjs-one-bg gjs-four-color-h",
                },
                category: "Aviso",
                content: 
                // eslint-disable-next-line no-template-curly-in-string
                '<mj-button href="${avisoMeetingLink}">Schedule Appointment</mj-button>',
            });
        }
        return () => {
            if (campaignTypeId === CampaignActionDomainService.AppointmentId &&
                editor.current != null) {
                editor.current.BlockManager.remove("appointment-block");
            }
        };
    });
    return (_jsxs("div", { children: [_jsx("div", { className: isInvalid ? "is-invalid" : "", children: _jsx("div", { id: id, 
                    /* eslint-disable-next-line react/no-danger */
                    dangerouslySetInnerHTML: {
                        __html: BASE_MJML_CONTENT,
                    } }) }), _jsx("div", { className: "invalid-feedback", children: invalidFeedback })] }));
};
export default Editor;
